import { createFeatureSelector } from '@ngrx/store';
import { FormDataKey, FormDataState } from '../reducers/form-data.reducer';
import { State } from '../index';

// Feature Selectors

export const selectFormData = createFeatureSelector< FormDataState>(
    FormDataKey,
);
